import React, { Component } from 'react';
import AuthService from './AuthService';

export default function withAuth(AuthComponent) {
  const Auth = new AuthService();
  return class AuthWrapped extends Component {
    constructor() {
      super();
      this.state = {
        user: null
      };
    }
    componentWillMount() {
      if (!Auth.loggedIn()) {
        this.props.history.replace('/login');
      } else {
        try {
          const user = Auth.getUser();
          this.setState({
            user: user
          });
        } catch (err) {
          Auth.logout();
          this.props.history.replace('/login');
        }
      }
    }
    render() {
      if (this.state.user) {
        return <AuthComponent user={this.state.user} {...this.props} />;
      } else {
        return null;
      }
    }
  };
}
